import React, { Dispatch, SetStateAction } from 'react'

/**
 * mask value of specified arg and allows to change it
 * like React.useState does, but updates inner value
 * when arg changed
 */
export const useMutableArg = <T>(arg: T) => {
  const [value, setValue] = React.useState<T>(arg)

  React.useEffect(() => {
    setValue(arg)
  }, [arg])

  return [value, setValue] as [T, Dispatch<SetStateAction<T>>]
}
